import { CoreIcon } from '../core-icon';
import chevronRightSVG from '../../../src/images/icons/chevron-right.svg';

export const ChevronRightIcon = props => {
  return <CoreIcon src={chevronRightSVG} {...props} />;
};
